var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navAssembly-nav",attrs:{"id":"navId"}},[_c('div',{staticClass:"navAssembly-navInner"},_vm._l((_vm.navList),function(item,index){return _c('span',{key:index,class:{ navActive: _vm.navShow == index },on:{"click":function($event){return _vm.navClick(item, index)}}},[_vm._v(_vm._s(item.name))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff4e98a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavAssembly.vue
// module id = null
// module chunks = 